<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-inspection modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ใบตรวจสภาพรถ</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-4">
                                    <div class="field">
                                        <label>เลขที่</label>
                                        <input type="text"
                                                v-model="formData.number"
                                                class="input-field"
                                                readonly />
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4">
                                    <div class="field">
                                        <label>วันที่ตรวจสภาพ</label>
                                        <input type="text"
                                                :value="$AppUtility.displayTimeFormat(formData.openDate)"
                                                class="input-field"
                                                readonly />
                                        <input type="hidden" v-model="formData.openDate" />
                                    </div>
                                </div>
                            </div>

                            <h2 class="sub-title mt-3 mb-3"><b-icon icon="disc-fill"></b-icon> รายการตรวจสภาพ</h2>

                            <section v-for="(item, index) in tireInspectionList" :key="index + 'Tire'">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>ขนาดยาง ({{ item.label }})</label>
                                            <input type="text"
                                                    v-model="formData[item.property].size"
                                                    class="input-field"
                                                    maxlength="20"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>ความสึกดอกยาง ({{ item.label }})</label>
                                            <div class="input-with-check">
                                                <input type="tel"
                                                    v-model="formData[item.property].worn"
                                                    class="input-field"
                                                    maxlength="3"
                                                    placeholder="มม."
                                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                                <div class="input-checkbox">
                                                    <checkbox class="field-checkbox"
                                                        v-model="formData[item.property].belowStandard" 
                                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                        ต่ำกว่ามาตรฐาน
                                                    </checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>สภาพเนื้อยาง ({{ item.label }})</label>
                                            <div class="input-checkbox-inline">
                                                <checkbox class="field-checkbox"
                                                    v-model="formData[item.property].tireStatus.checkGroup.statusNormal"
                                                    @change="changeCheckboxGroup($event, item.property, 'statusNormal', 'tireStatus')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    ปกติ
                                                </checkbox>
                                                <checkbox class="field-checkbox ml-3"
                                                    v-model="formData[item.property].tireStatus.checkGroup.statusProblem"
                                                    @change="changeCheckboxGroup($event, item.property, 'statusProblem', 'tireStatus')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    ผิดปกติ
                                                </checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="dashed-line mt-2 mb-3"></div>

                            <section v-for="(item, index) in brakeInspectionList" :key="index + 'Brake'">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>ความหนาเนื้อผ้าเบรก ({{ item.label }})</label>
                                            <div class="input-with-check">
                                                <input type="tel"
                                                    v-model="formData[item.property].brakePadSize"
                                                    class="input-field"
                                                    maxlength="3"
                                                    placeholder="มม."
                                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                                <div class="input-checkbox">
                                                    <checkbox class="field-checkbox"
                                                        v-model="formData[item.property].brakePadChangeSuggest" 
                                                        :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                        ต่ำกว่ามาตรฐาน
                                                    </checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>สภาพเนื้อผ้าเบรก ({{ item.label }})</label>
                                            <div class="input-checkbox-inline">
                                                <checkbox class="field-checkbox"
                                                    v-model="formData[item.property].brakePad.checkGroup.brakePadNormal"
                                                    @change="changeCheckboxGroup($event, item.property, 'brakePadNormal', 'brakePad')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    ปกติ
                                                </checkbox>
                                                <checkbox class="field-checkbox ml-3"
                                                    v-model="formData[item.property].brakePad.checkGroup.brakePadProblem"
                                                    @change="changeCheckboxGroup($event, item.property, 'brakePadProblem', 'brakePad')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    ผิดปกติ
                                                </checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-4">
                                        <div class="field">
                                            <label>จานเบรก ({{ item.label }})</label>
                                            <div class="input-checkbox-inline">
                                                <checkbox class="field-checkbox"
                                                    v-model="formData[item.property].brakeDisc.checkGroup.brakeDiscNormal"
                                                    @change="changeCheckboxGroup($event, item.property, 'brakeDiscNormal', 'brakeDisc')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    ปกติ
                                                </checkbox>
                                                <checkbox class="field-checkbox ml-3"
                                                    v-model="formData[item.property].brakeDisc.checkGroup.brakeDiscProblem"
                                                    @change="changeCheckboxGroup($event, item.property, 'brakeDiscProblem', 'brakeDisc')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    มีรอย
                                                </checkbox>
                                                <checkbox class="field-checkbox ml-3" 
                                                    v-model="formData[item.property].brakeDisc.checkGroup.brakeDiscThin" 
                                                    @change="changeCheckboxGroup($event, item.property, 'brakeDiscThin', 'brakeDisc')"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                    บาง
                                                </checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div class="dashed-line mt-2 mb-3"></div>

                            <div class="row">
                                <div class="col-12 col-sm-6" v-for="(item, index) in absorberInspectionList" :key="index + 'Absorber'">
                                    <div class="field">
                                        <label>โช๊คอัพ ({{ item.label }})</label>
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData[item.property].absorberStatus.checkGroup.normal"
                                                @change="changeCheckboxGroup($event, item.property, 'normal', 'absorberStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ปกติ
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData[item.property].absorberStatus.checkGroup.leak"
                                                @change="changeCheckboxGroup($event, item.property, 'leak', 'absorberStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                รั่วซึม
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData[item.property].absorberStatus.checkGroup.degenerate"
                                                @change="changeCheckboxGroup($event, item.property, 'degenerate', 'absorberStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                เสื่อมสภาพ
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dashed-line mt-2 mb-3"></div>

                            <div class="row">
                                <div class="col-12 col-sm-6" v-for="(item, index) in absorberEquipmentInspectionList" :key="index + 'AbsorberEquipment'">
                                    <div class="field">
                                        <label>อุปกรณ์โช๊คอัพ ({{ item.label }})</label>
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData[item.property].absorberEquipment.checkGroup.normal"
                                                @change="changeCheckboxGroup($event, item.property, 'normal', 'absorberEquipment')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ปกติ
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData[item.property].absorberEquipment.checkGroup.prbblem"
                                                @change="changeCheckboxGroup($event, item.property, 'prbblem', 'absorberEquipment')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ผิดปกติ
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dashed-line mt-2 mb-3"></div>

                            <div class="row">
                                <div class="col-12 col-sm-6 col-md-4">
                                    <div class="field">
                                        <label>แบตเตอรี่รุ่น</label>
                                        <input type="text"
                                                v-model="formData.battery.name"
                                                class="input-field"
                                                maxlength="50"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4">
                                    <div class="field">
                                        <label>ประเภทแบตเตอรี่</label>
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData.battery.type.checkGroup.typeSMF"
                                                @change="changeCheckboxGroup($event, 'battery', 'typeSMF', 'type')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                เติมน้ำกลั่น
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData.battery.type.checkGroup.typeMF"
                                                @change="changeCheckboxGroup($event, 'battery', 'typeMF', 'type')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                MF
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6 col-md-4">
                                    <div class="field">
                                        <label>ตำแหน่งขั้วแบตเตอรี่</label>
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData.battery.position.checkGroup.positionR"
                                                @change="changeCheckboxGroup($event, 'battery', 'positionR', 'position')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                R
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData.battery.position.checkGroup.positionL"
                                                @change="changeCheckboxGroup($event, 'battery', 'positionL', 'position')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                L
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>แรงดันไฟฟ้า</label>
                                        <input type="tel"
                                            v-model="formData.battery.power"
                                            class="input-field"
                                            maxlength="3"
                                            placeholder="V."
                                            @keypress="$AppUtility.inputOnlyNumber($event)"
                                            :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                    </div>
                                    <div class="field">
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData.battery.powerStatus.checkGroup.powerNormal"
                                                @change="changeCheckboxGroup($event, 'battery', 'powerNormal', 'powerStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ปกติ
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData.battery.powerStatus.checkGroup.powerProblem"
                                                @change="changeCheckboxGroup($event, 'battery', 'powerProblem', 'powerStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ผิดปกติ
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="field">
                                        <label>ค่า CCA</label>
                                        <input type="tel"
                                            v-model="formData.battery.cca"
                                            class="input-field"
                                            maxlength="3"
                                            @keypress="$AppUtility.inputOnlyNumber($event)"
                                            :readonly="jobState === $Constants.JOB_STATUS_COMPLETE" />
                                    </div>
                                    <div class="field">
                                        <div class="input-checkbox-inline">
                                            <checkbox class="field-checkbox"
                                                v-model="formData.battery.ccaStatus.checkGroup.ccaNormal" 
                                                @change="changeCheckboxGroup($event, 'battery', 'ccaNormal', 'ccaStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ปกติ
                                            </checkbox>
                                            <checkbox class="field-checkbox ml-3"
                                                v-model="formData.battery.ccaStatus.checkGroup.ccaBelowStandard"
                                                @change="changeCheckboxGroup($event, 'battery', 'ccaBelowStandard', 'ccaStatus')"
                                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                                ต่ำกว่ามาตรฐาน
                                            </checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="dashed-line mt-2 mb-3"></div>

                            <div class="row">
                                <div v-for="(field, indexField) in checkBoxField" :key="indexField" class="col-md-12 col-lg-6">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-4">
                                            <label>{{ field.name }}</label>
                                        </div>
                                        <div class="col-sm-12 col-md-8">
                                            <div class="field-inline">
                                                <checkbox
                                                    v-for="(input, indexInput) in field.checkBox" 
                                                    :key="indexInput"
                                                    v-model="formData.checkList[field.group].checkGroup[input.property]" 
                                                    @change="changeCheckListCheckboxGroup($event, field.group, input.property)"
                                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                                    class="field-checkbox"
                                                    :class="{ 'ml-3': indexInput > 0 }">
                                                    {{ input.name }}
                                                </checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="dashed-line mt-3 mb-3"></div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <label>รายละเอียดอื่นๆ</label>
                                        <textarea
                                            class="input-field"
                                            rows="3"
                                            v-model="formData.detail"
                                            maxlength="500"
                                            :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="mb-3"></div>
                            
                            <div class="text-right">
                                <button class="btn btn-green" @click="saveCarInspection()">บันทึก</button>
                                <button class="btn btn-main" @click="printInspection()">PRINT</button>
                                <button class="btn btn-grey-outline ml-4" @click="hide()">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <print-document ref="refPrintDocument" :printTemplate="$Constants.PRINT_TYPE_INSPECTION"></print-document>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import Checkbox from '@/components/utility/Checkbox.vue';
import PrintDocument from '@/components/print/PrintTemplate';
import DBInspection from '@/database/Inspection';
import DBStore from '@/database/Store';

export default {
    components: {
        PrintDocument,
        Checkbox
    },
    data() {
        return {
            isActive: false,
            tireInspectionList: [
                { property: 'tireFrontLeft', label: 'หน้าซ้าย' },
                { property: 'tireFrontRight', label: 'หน้าขวา' },
                { property: 'tireBackLeft', label: 'หลังซ้าย' },
                { property: 'tireBackRight', label: 'หลังขวา' },
            ],
            brakeInspectionList: [
                { property: 'brakeFrontLeft', label: 'หน้าซ้าย' },
                { property: 'brakeFrontRight', label: 'หน้าขวา' },
                { property: 'brakeBackLeft', label: 'หลังซ้าย' },
                { property: 'brakeBackRight', label: 'หลังขวา' },
            ],
            absorberInspectionList: [
                { property: 'absorberFrontLeft', label: 'หน้าซ้าย' },
                { property: 'absorberFrontRight', label: 'หน้าขวา' },
                { property: 'absorberBackLeft', label: 'หลังซ้าย' },
                { property: 'absorberBackRight', label: 'หลังขวา' },
            ],
            absorberEquipmentInspectionList: [
                { property: 'absorberEquipmentFrontLeft', label: 'หน้าซ้าย' },
                { property: 'absorberEquipmentFrontRight', label: 'หน้าขวา' },
                { property: 'absorberEquipmentBackLeft', label: 'หลังซ้าย' },
                { property: 'absorberEquipmentBackRight', label: 'หลังขวา' },
            ],
            checkBoxField: [],
            formData: null,
            errorData: null
        };
    },
    props: {
        isDisplay: Boolean,
        keyData: String,
        docNumber: String,
        customerData: Object,
        jobType: Object,
        jobState: Number
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;
            this.$root.$emit('rootSetContentScrollable', !value);

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    mounted() {
        this.checkBoxField = this.initCheckBoxField();
    },
    methods: {
        hide() {
            this.$emit('hide', null);
        },
        changeCheckboxGroup(value, property, current, parentProperty) {
            if (value) {
                for (const field in this.formData[property][parentProperty].checkGroup) {
                    if (field !== current) {
                        this.formData[property][parentProperty].checkGroup[field] = false;
                    }
                }
            }
        },
        changeCheckListCheckboxGroup(value, property, current) {
            if (value) {
                for (const field in this.formData.checkList[property].checkGroup) {
                    if (field !== current) {
                        this.formData.checkList[property].checkGroup[field] = false;
                    }
                }
            }
        },
        async initFormData() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            let data = null;

            if (this.keyData) {
                data = await DBInspection.getDetail(this.keyData);
            }

            loader.hide();

            return this.mapViewData(data);
        },
        initCheckBoxField() {
            return [
                {
                    name: 'น้ำมันเครื่อง',
                    group: 'engineOil',
                    checkBox: [
                        { name: 'ปกติ', property: 'engineNormal' },
                        { name: 'ขาด', property: 'engineTooLow' },
                        { name: 'เกินระยะ', property: 'engineOverDistance' }
                    ]
                },
                {
                    name: 'น้ำมันเบรก',
                    group: 'brakeOil',
                    checkBox: [
                        { name: 'ปกติ', property: 'brakeNormal' },
                        { name: 'ขาด', property: 'brakeTooLow' },
                        { name: 'เกินระยะ', property: 'brakeOverDistance' }
                    ]
                },
                {
                    name: 'น้ำมันคลัตช์',
                    group: 'clutchOil',
                    checkBox: [
                        { name: 'ปกติ', property: 'clutchNormal' },
                        { name: 'ขาด', property: 'clutchTooLow' },
                        { name: 'เกินระยะ', property: 'clutchOverDistance' }
                    ]
                },
                {
                    name: 'น้ำมันเกียร์',
                    group: 'gearOil',
                    checkBox: [
                        { name: 'ปกติ', property: 'gearNormal' },
                        { name: 'ขาด', property: 'gearTooLow' },
                        { name: 'เกินระยะ', property: 'gearOverDistance' }
                    ]
                },
                {
                    name: 'น้ำมันพาวเวอร์',
                    group: 'powerOil',
                    checkBox: [
                        { name: 'ปกติ', property: 'powerNormal' },
                        { name: 'ขาด', property: 'powerTooLow' },
                        { name: 'เกินระยะ', property: 'powerOverDistance' }
                    ]
                },
                {
                    name: 'หม้อน้ำ',
                    group: 'boiler',
                    checkBox: [
                        { name: 'ปกติ', property: 'boilerNormal' },
                        { name: 'ผิดปกติ', property: 'boilerProblem' }
                    ]
                },
                {
                    name: 'ใบปัดน้ำฝน',
                    group: 'wiperBlade',
                    checkBox: [
                        { name: 'ปกติ', property: 'wiperBladeNormal' },
                        { name: 'ฉีกขาด', property: 'wiperBladeTorn' },
                        { name: 'ยางแข็ง', property: 'wiperBladeHard' }
                    ]
                },
                {
                    name: 'น้ำฉีดกระจก',
                    group: 'glassWater',
                    checkBox: [
                        { name: 'ปกติ', property: 'glassWaterNormal' },
                        { name: 'รั่ว', property: 'glassWaterLeak' },
                        { name: 'พร่อง', property: 'glassWaterDeplete' }
                    ]
                },
                {
                    name: 'ท่อยางหม้อน้ำ',
                    group: 'radiatorHose',
                    checkBox: [
                        { name: 'ปกติ', property: 'radiatorHoseNormal' },
                        { name: 'เสื่อมสภาพ', property: 'radiatorHoseDegenerate' }
                    ]
                },
                {
                    name: 'กรองอากาศ',
                    group: 'airFilter',
                    checkBox: [
                        { name: 'ปกติ', property: 'airFilterNormal' },
                        { name: 'สกปรก', property: 'airFilterDirty' },
                        { name: 'อุดตัน', property: 'airFilterBlock' }
                    ]
                },
                {
                    name: 'สายพานไดชาร์จ',
                    group: 'alternator',
                    checkBox: [
                        { name: 'ปกติ', property: 'alternatorNormal' },
                        { name: 'แตกร้าว', property: 'alternatorCrack' }
                    ]
                },
                {
                    name: 'สายพานพาวเวอร์',
                    group: 'powerBelt',
                    checkBox: [
                        { name: 'ปกติ', property: 'powerBeltNormal' },
                        { name: 'แตกร้าว', property: 'powerBeltCrack' }
                    ]
                },
                {
                    name: 'สายพานแอร์',
                    group: 'airBelt',
                    checkBox: [
                        { name: 'ปกติ', property: 'airBeltNormal' },
                        { name: 'แตกร้าว', property: 'airBeltCrack' }
                    ]
                },
                {
                    name: 'น้ำยาแอร์',
                    group: 'refrigerant',
                    checkBox: [
                        { name: 'ปกติ', property: 'refrigerantNormal' },
                        { name: 'พร่อง', property: 'refrigerantDeplete' }
                    ]
                },
                {
                    name: 'กรองแอร์',
                    group: 'airCondFilter',
                    checkBox: [
                        { name: 'ปกติ', property: 'airCondFilterNormal' },
                        { name: 'สกปรก/เสื่อมสภาพ', property: 'airCondFilterDirty' }
                    ]
                },
                {
                    name: 'น้ำยาท่อแอร์',
                    group: 'refrigerantPipe',
                    checkBox: [
                        { name: 'ปกติ', property: 'refrigerantPipeNormal' },
                        { name: 'เสื่อมสภาพ', property: 'refrigerantPipeDegenerate' }
                    ]
                },
                {
                    name: 'ตู้แอร์',
                    group: 'airBox',
                    checkBox: [
                        { name: 'ปกติ', property: 'airBoxNormal' },
                        { name: 'อุดตัน', property: 'airBoxBlock' },
                        { name: 'รั่ว', property: 'airBoxLeak' }
                    ]
                },
                {
                    name: 'คอมเพรสเซอร์แอร์',
                    group: 'compressor',
                    checkBox: [
                        { name: 'ปกติ', property: 'compressorNormal' },
                        { name: 'ผิดปกติ', property: 'compressorProblem' }
                    ]
                },
                {
                    name: 'คอนเดนเซอร์แอร์',
                    group: 'condenser',
                    checkBox: [
                        { name: 'ปกติ', property: 'condenserNormal' },
                        { name: 'สกปรก/อุดตัน', property: 'condenserBlock' },
                        { name: 'รั่ว', property: 'condenserLeak' }
                    ]
                },
                {
                    name: 'พัดลมหน้าเครื่อง/แอร์',
                    group: 'airFan',
                    checkBox: [
                        { name: 'ปกติ', property: 'airFanNormal' },
                        { name: 'ผิดปกติ', property: 'airFanProblem' }
                    ]
                },
                {
                    name: 'สายอ่อนเบรกหน้า/หลัง',
                    group: 'airFan',
                    checkBox: [
                        { name: 'ปกติ', property: 'brakeHoseNormal' },
                        { name: 'แตกร้าว', property: 'brakeHoseCrack' }
                    ]
                },
                {
                    name: 'คาลิปเปอร์หน้า/หลัง',
                    group: 'caliper',
                    checkBox: [
                        { name: 'ปกติ', property: 'caliperNormal' },
                        { name: 'ผิดปกติ', property: 'caliperProblem' }
                    ]
                },
                {
                    name: 'กระบอกเบรกหลัง',
                    group: 'brakeCylinder',
                    checkBox: [
                        { name: 'ปกติ', property: 'brakeCylinderNormal' },
                        { name: 'รั่วซึม', property: 'brakeCylinderLeak' }
                    ]
                },
                {
                    name: 'แม่ปั๊มเบรก',
                    group: 'masterCylinder',
                    checkBox: [
                        { name: 'ปกติ', property: 'masterCylinderNormal' },
                        { name: 'รั่วซึม', property: 'masterCylinderLeak' }
                    ]
                },
                {
                    name: 'ลูกปืนล้อหน้า/หลัง',
                    group: 'wheelBearing',
                    checkBox: [
                        { name: 'ปกติ', property: 'wheelBearingNormal' },
                        { name: 'ผิดปกติ', property: 'wheelBearingProblem' }
                    ]
                },
                {
                    name: 'ลูกหมากปีกนกบน/ล่าง',
                    group: 'ballJoint',
                    checkBox: [
                        { name: 'ปกติ', property: 'ballJointNormal' },
                        { name: 'ผิดปกติ', property: 'ballJointProblem' }
                    ]
                },
                {
                    name: 'ลูกหมากกันโคลง/ล่าง',
                    group: 'stabilizerLink',
                    checkBox: [
                        { name: 'ปกติ', property: 'stabilizerLinkNormal' },
                        { name: 'ผิดปกติ', property: 'stabilizerLinkProblem' }
                    ]
                },
                {
                    name: 'ลูกหมากแร็คนอก/ใน',
                    group: 'axialRod',
                    checkBox: [
                        { name: 'ปกติ', property: 'axialRodNormal' },
                        { name: 'ผิดปกติ', property: 'axialRodProblem' }
                    ]
                },
                {
                    name: 'ยางหุ้มเพลานอก/ใน',
                    group: 'shaftCover',
                    checkBox: [
                        { name: 'ปกติ', property: 'shaftCoverNormal' },
                        { name: 'เสื่อมสภาพ', property: 'shaftCoverDegenerate' },
                        { name: 'ฉีกขาด', property: 'shaftCoverTorn' }
                    ]
                },
                {
                    name: 'ไฟหน้า/ไฟสูง',
                    group: 'headLight',
                    checkBox: [
                        { name: 'ปกติ', property: 'headLightNormal' },
                        { name: 'ผิดปกติ', property: 'headLightProblem' }
                    ]
                },
                {
                    name: 'ไฟหรี่',
                    group: 'dimmer',
                    checkBox: [
                        { name: 'ปกติ', property: 'dimmerNormal' },
                        { name: 'ผิดปกติ', property: 'dimmerProblem' }
                    ]
                },
                {
                    name: 'ไฟเลี้ยวหน้า/หลัง',
                    group: 'turnSignal',
                    checkBox: [
                        { name: 'ปกติ', property: 'turnSignalNormal' },
                        { name: 'ผิดปกติ', property: 'turnSignalProblem' }
                    ]
                },
                {
                    name: 'ไฟท้าย',
                    group: 'tailLight',
                    checkBox: [
                        { name: 'ปกติ', property: 'tailLightNormal' },
                        { name: 'ผิดปกติ', property: 'tailLightProblem' }
                    ]
                },
                {
                    name: 'ไฟเบรก',
                    group: 'brakeLight',
                    checkBox: [
                        { name: 'ปกติ', property: 'brakeLightNormal' },
                        { name: 'ผิดปกติ', property: 'brakeLightProblem' }
                    ]
                }
            ];
        },
        initCheckListData(data) {
            let checkList = {};

            this.checkBoxField.forEach((fieldItem) => {
                fieldItem.checkBox.forEach((checkBoxItem) => {
                    let dataField = {};
                    dataField[fieldItem.group] = { checkGroup: {} };
                    dataField[fieldItem.group].checkGroup[checkBoxItem.property] = data ? data[fieldItem.group].checkGroup[checkBoxItem.property] : false;

                    checkList = Object.assign(checkList, dataField);
                });
            });

            return checkList;
        },
        mapViewData(data) {
            return {
                key: this.keyData,
                number: data ? data.number : this.generateDocumentNumber(),
                openDate: data ? data.openDate : new Date(),
                tireFrontLeft: data ? data.tireFrontLeft : this.getTireField(),
                tireFrontRight: data ? data.tireFrontRight : this.getTireField(),
                tireBackLeft: data ? data.tireBackLeft : this.getTireField(),
                tireBackRight: data ? data.tireBackRight : this.getTireField(),
                brakeFrontLeft: data ? data.brakeFrontLeft : this.getBrakeField(),
                brakeFrontRight: data ? data.brakeFrontRight : this.getBrakeField(),
                brakeBackLeft: data ? data.brakeBackLeft : this.getBrakeField(),
                brakeBackRight: data ? data.brakeBackRight : this.getBrakeField(),
                absorberFrontLeft: data ? data.absorberFrontLeft : this.getAbsorberField(),
                absorberFrontRight: data ? data.absorberFrontRight : this.getAbsorberField(),
                absorberBackLeft: data ? data.absorberBackLeft : this.getAbsorberField(),
                absorberBackRight: data ? data.absorberBackRight : this.getAbsorberField(),
                absorberEquipmentFrontLeft: data ? data.absorberEquipmentFrontLeft : this.getAbsorberEquipmentField(),
                absorberEquipmentFrontRight: data ? data.absorberEquipmentFrontRight : this.getAbsorberEquipmentField(),
                absorberEquipmentBackLeft: data ? data.absorberEquipmentBackLeft : this.getAbsorberEquipmentField(),
                absorberEquipmentBackRight: data ? data.absorberEquipmentBackRight : this.getAbsorberEquipmentField(),
                battery: data ? data.battery : this.getBattteryField(),
                checkList: data ? data.checkList : this.initCheckListData()
            }
        },
        getTireField() {
            return {
                size: '',
                worn: '',
                belowStandard: false,
                tireStatus: {
                    checkGroup: {
                        statusNormal: false,
                        statusProblem: false
                    }
                }
            };
        },
        getBrakeField() {
            return {
                brakePadSize: '',
                brakePadChangeSuggest: false,
                brakePad: {
                    checkGroup: {
                        brakePadNormal: false,
                        brakePadProblem: false,
                    }
                },
                brakeDisc: {
                    checkGroup: {
                        brakeDiscNormal: false,
                        brakeDiscProblem: false,
                        brakeDiscThin: false
                    }
                }
            };
        },
        getAbsorberField() {
            return {
                absorberStatus: {
                    checkGroup: {
                        normal: false,
                        leak: false,
                        degenerate: false
                    }
                }
            };
        },
        getAbsorberEquipmentField() {
            return {
                absorberEquipment: {
                    checkGroup: {
                        normal: false,
                        problem: false
                    }
                }
            };
        },
        getBattteryField() {
            return {
                name: '',
                type: {
                    checkGroup: {
                        typeSMF: false,
                        typeMF: false,
                    }
                },
                position: {
                    checkGroup: {
                        positionR: false,
                        positionL: false,
                    }
                },
                power: '',
                powerStatus: {
                    checkGroup: {
                        powerNormal: false,
                        powerProblem: false,
                    }
                },
                cca: '',
                ccaStatus: {
                    checkGroup: {
                        ccaNormal: false,
                        ccaBelowStandard: false
                    }
                }
            };
        },
        generateDocumentNumber() {
            return 'I' + this.docNumber.substring(1);
        },
        initValidateData() {
            return {
                form: { blank: false }
            }
        },
        async saveCarInspection() {
            const loader = this.$AppUtility.renderLoadBackdrop();

            await DBInspection.save(this.formData);

            this.hide();
            loader.hide();
        },
        async printInspection() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const storeData = await DBStore.get();
            const content = {
                data: this.formData,
                store: storeData.content
            };
            content.data = Object.assign(content.data, { checkListField: this.checkBoxField });
            content.data = Object.assign(content.data, this.customerData);
            content.data = Object.assign(content.data, this.jobType);
            
            loader.hide();

            this.$refs.refPrintDocument.printForm(content);
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.modal-inspection {
    max-width: 1000px;

    h3 {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .input-field {
        font-size: 13px;
        padding: 6px 15px;
    }

    .field-checkbox {
        font-size: 13px;
    }
}
</style>